// 掲示物プレビュー。docs/prototype.html の materialSheetHTML() を Reactコンポーネント化したもの。
// HQの作成画面プレビューと、各社ポータルの詳細表示の両方で使う共有部品。
import type { Material } from "../types";

const URGENCY_LABEL: Record<string, string> = { 高: "緊急・要対応", 中: "ご確認ください", 低: "お知らせ" };
const URGENCY_ICON: Record<string, string> = { 高: "🔴", 中: "🟠", 低: "🔵" };

export function MaterialSheet({ material: m }: { material: Partial<Material> }) {
  const urgency = m.urgency || "低";
  const points = (m.points || []).filter(Boolean);
  const actions = (m.actions || []).filter(Boolean);

  return (
    <div className={`sheet u-${urgency}`}>
      <div className={`s-ribbon u-${urgency}`}>
        {URGENCY_ICON[urgency]} {URGENCY_LABEL[urgency]}
        <span className="s-cat">{m.category || "一般連絡・お知らせ"}</span>
      </div>
      <div className="s-head">
        <div className="s-org">{m.org || "薬局内 情報伝達"}</div>
        <div className="s-date">掲示日 {m.date || ""}</div>
      </div>
      <h3 className="s-title">{m.title || "(タイトル未設定)"}</h3>
      {m.summary && (
        <div className="s-summary">
          <span>💡</span>
          <div>{m.summary}</div>
        </div>
      )}
      {(m.target || m.deadline) && (
        <div className="s-info">
          {m.target && (
            <div className="cell">
              <div className="ck">🎯 対象</div>
              <div className="cv">{m.target}</div>
            </div>
          )}
          {m.deadline && (
            <div className="cell hot">
              <div className="ck">⏰ 期限</div>
              <div className="cv">{m.deadline}</div>
            </div>
          )}
        </div>
      )}
      {points.length > 0 && (
        <div className="s-sec">
          <h4>📌 ポイント</h4>
          <ul className="s-list">
            {points.map((p, i) => (
              <li key={i}>{p}</li>
            ))}
          </ul>
        </div>
      )}
      {actions.length > 0 && (
        <div className="s-sec act">
          <h4>✅ やること</h4>
          <ul className="s-check">
            {actions.map((a, i) => (
              <li key={i}>
                <span className="box" />
                {a}
              </li>
            ))}
          </ul>
        </div>
      )}
      {m.body && (
        <div className="s-sec">
          <h4>補足</h4>
          <div className="s-note">{m.body}</div>
        </div>
      )}
      <div className="s-foot">
        <span>{m.contact ? `☎ ${m.contact}` : "薬局 情報伝達ハブ"}</span>
        <span>
          {m.sourcePdfName ? `元PDF: ${m.sourcePdfName}　/　` : ""}ID: {m.id || "draft"}
        </span>
      </div>
    </div>
  );
}
